import { useQuery } from '@tanstack/react-query'
import { CONFIGURACOES_PADRAO, type Configuracoes } from '@peniel/shared'

import { obterConfigLoja } from '../api/config.js'
import { chaves } from '../api/chaves.js'

/**
 * Defaults como objeto simples, NÃO via `esquemaConfiguracoes.parse({})`:
 * aquela chamada arrastava o zod inteiro (18,5 KB gzip) para o bundle do
 * visitante só para ler constantes.
 */
const PADROES: Configuracoes = CONFIGURACOES_PADRAO

/**
 * Configurações da loja (WhatsApp, endereço, textos do hero).
 *
 * `initialData` com os defaults do contrato: o rodapé e o botão de WhatsApp
 * renderizam na PRIMEIRA pintura, sem esperar a rede e sem piscar. Se a API
 * responder algo diferente, o React re-renderiza — mas nunca há um estado
 * intermediário com o telefone vazio.
 */
export function useConfigLoja() {
  const consulta = useQuery({
    queryKey: chaves.config.loja,
    queryFn: obterConfigLoja,
    // Muda só quando o dono edita a tela de configurações.
    staleTime: 5 * 60_000,
    initialData: PADROES,
  })

  return consulta.data
}
